import React from "react";
import ReactCountdown, { type CountdownRenderProps, type CountdownProps as ReactCountdownProps } from "react-countdown";

export type CountdownProps = Omit<ReactCountdownProps, "renderer"> & {};

const Countdown = (props: CountdownProps) => {
  const renderer = React.useCallback(
    (args: CountdownRenderProps) => (
      <span>
        {args.formatted.minutes}:{args.formatted.seconds}
      </span>
    ),
    []
  );

  return <ReactCountdown {...props} renderer={renderer} />;
};

export default Countdown;
